import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { useState } from "react";
import { Input } from "../../../ui/input";
import { useEffect } from "react";

export const ChangeUsername = ({ children, setUsername }: { children: React.ReactNode, setUsername: any }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [usernamee, setUsernameC] = useState("");
    const [disabled, setDisabled] = useState(true);

    useEffect(() => {
        const slugRegex = /^[\p{L}0-9_ -\u{1F600}-\u{1F64F}]*$/u;
        if (!usernamee) { setDisabled(true); return; }
        if ((usernamee).trim().length < 1 || (usernamee).trim().length > 12) { setDisabled(true); return; }
        if (slugRegex.test(usernamee)) { setDisabled(false); }
        else { setDisabled(true); }
    }, [usernamee]);

    const requestSlug = async () => {
        setDisabled(true);
        const response = await fetch('__SITE_BASE__/api/me/profile/username', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ username: usernamee }),
        });
        const data = await response.json();
        if (!data.success) {
            setDisabled(false);
            return;
        }
        setUsername(data.username);
        setIsOpen(false);
    }
    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger>
                {children}
            </DialogTrigger>
            <DialogContent className="bg-brand-dark text-white border-0 rounded-lg">
                <DialogHeader className="items-start justify-start">
                    <DialogTitle>
                        Change your username
                    </DialogTitle>
                    <DialogDescription />
                </DialogHeader>

                <div className="flex flex-col space-y-4">
                    <Input
                        type="text"
                        id="Username"
                        className="bg-brand-back rounded border-0"
                        value={usernamee}
                        onChange={(e) => setUsernameC(e.target.value)}
                        placeholder="Username"
                        autoComplete="off"

                    />
                    <div className="flex justify-end">
                        <Button
                            onClick={() => {
                                requestSlug();
                            }}

                            className="bg-brand-green px-5 py-2 rounded-lg text-white font-semibold hover:bg-green-500"
                            disabled={disabled}
                        >
                            Submit
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};
